"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Price = void 0;
var typebox_1 = require("@sinclair/typebox");
var currency_1 = require("./currency");
exports.Price = typebox_1.Type.Object({
    currency: currency_1.Currency,
    amount: typebox_1.Type.Integer(),
}, { title: "Price" });
